module.exports = __webpack_public_path__ + "static/media/rip.c7782c9e.JPG";